import * as React from 'react';
import CurrencyElement from '@appComponents/CurrencyElement/CurrencyElement';

import * as style from './ClaimRowStyles.module.scss'

const dotsBackgrounds = ['#d026ff', '#37a1ff', '#f7b501', '#48aa43', '#ee4b2b'];
type Props = {
  index: number;
  loss_name: string;
  amount: number;
};

export const ClaimRow = ({ index, loss_name, amount }: Props) => {
  const paintDot = (i: number) => {
    return { background: dotsBackgrounds[i] } as React.CSSProperties;
  };

  const mapLossName = (k: string) => {
    const lossNameMapping: {[index: string]: string} = {
      'loss_in_usd_earn': 'General Earn Claims',
      'loss_in_usd_custody': 'General Custody Claims',
      'loss_in_usd_withheld': 'Withhold Claims',
      'loss_in_usd_loan': 'Retail Advance Obligation (outstanding loan amount)',
      'loss_in_usd_collateral': 'Retail Borrower Deposit Claim',
      'loss_in_usd_post_set': 'Retail Borrower Post-Set Off Claim',
    };
    return lossNameMapping[k] || 'Unknown';
  };

    return (
      <div className={[style.claimRow, style.decoration].join(' ')}>
        <div className={[style.item, style.itemName].join(' ')}>
          <div>
            <div
              className={style.dot}
              style={paintDot(index)}
            />
            { mapLossName(loss_name)}
          </div>
        </div>
        <div className={[style.item, style.itemValues].join(' ')}>
          <CurrencyElement
            currency={'USD'}
            value={amount}
            dataCy={`${loss_name}-balance`}
          />
        </div>
      </div>
  );
};
